import { fields } from 'iron-forge-react-modules';



/**
 * Return reasons are pulled from here:
 *
 * https://metisoft.atlassian.net/browse/QIPC-13637
 */

export interface IReasonForReturn {
  id: string;
  label: string;
}

export function genComponentAndControllerGenerator() {
  return fields.ObjectSelectField.genComponentAndControllerGenerator({
    useGetObjects: () => {
      return {
        refetch: async () => { },
        loading: false,
        data: {
          objects: [
            {
              id: 'Better price available',
              label: "Better price available"
            },
            {
              id: 'Bought by mistake',
              label: "Bought by mistake"
            },
            {
              id: 'Data or MMS not working',
              label: "Data or MMS not working"
            },
            {
              id: 'Inaccurate website description',
              label: "Inaccurate website description"
            },
            {
              id: 'Issue with Battery',
              label: "Issue with Battery"
            },
            {
              id: 'Issue with Camera',
              label: "Issue with Camera"
            },
            {
              id: 'Issue with Service',
              label: "Issue with Service"
            },
            {
              id: 'Issue with Speaker or Mic',
              label: "Issue with Speaker or Mic"
            },
            {
              id: 'Issue with Software',
              label: "Issue with Software"
            },
            {
              id: 'Item defective or doesn\'t work',
              label: "Item defective or doesn't work"
            },
            {
              id: 'Items arrived too late',
              label: "Items arrived too late"
            },
            {
              id: 'Missing or broken parts',
              label: "Missing or broken parts"
            },
            {
              id: 'No longer needed',
              label: "No longer needed"
            },
            {
              id: 'Product and shipping box both damaged',
              label: "Product and shipping box both damaged"
            },
            {
              id: 'Product damaged, but shipping box OK',
              label: "Product damaged, but shipping box OK"
            },
            {
              id: 'Wrong item was sent',
              label: "Wrong item was sent"
            }
          ]
        }
      };
    },
    fnGetObjectLabel: object => object.label
  });
}
